interface HourDropdownProps {
  value: string;
  onChange: (newVal: string) => void;
  className?: string;
}

export default function HourDropdown({ value, onChange, className = '' }: HourDropdownProps) {
  const hours: string[] = [];
  for (let i = 0; i < 24; i++) {
    const hour = i.toString().padStart(2, '0') + ':00';
    hours.push(hour);
  }

  return (
    <select
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      className={`px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-24 focus:border-blue-500 ${className}`}
    >
      {hours.map((hour: string) => (
        <option key={hour} value={hour}>
          {hour}
        </option>
      ))}
    </select>
  );
}
